<template>
  <div class="home">
    <Empresa v-if="user.includes('Company')" />
    <ComercialInterno v-else-if="user.includes('InternalCommercial')" />
    <ComercialExterno v-else-if="user.includes('ExternalCommercial')" />
    <Tasador v-else-if="user.includes('Appraiser')" />
    <Validador v-else-if="user.includes('Validator')" />
  </div>
</template>

<script>
import Empresa from "../components/Home/Home-Company.vue";
import ComercialInterno from "../components/Home/Home-InternalCommercial.vue";
import ComercialExterno from "../components/Home/Home-ExternalCommercial.vue";
import Tasador from "../components/Home/Home-Appraiser.vue";
import Validador from "../components/Home/Home-Validator.vue";
export default {
  name: "Home",
  components: {
    Empresa,
    ComercialExterno,
    ComercialInterno,
    Tasador,
    Validador
  },
  computed: {
    user() {
      let arr = [];
      this.$store.state.userLogged.roles.forEach(element => {
        arr.push(element.rol);
      });
      return arr;
    }
  }
};
</script>
